var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"StaticLayout"}},[_c('header-vue',{style:(_vm.cor)}),_vm._v(" "),_c('div',{staticClass:"content-center bg-gray"},[_c('router-view')],1),_vm._v(" "),_c('footer-vue',{style:(_vm.cor)})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12ab6caa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/StaticLayout.vue
// module id = GVxo
// module chunks = 1